import "@fortawesome/fontawesome-free/css/all.min.css";
import { Button } from "@mui/material";

interface Props {
  handleExportToExcel: () => void;
  disabled?: boolean;
  label?: String;
}

export const ExcelButton = ({
  handleExportToExcel,
  disabled,
  label = "EXPORT TO EXCEL",
}: Props) => {
  return (
    <Button
      fullWidth
      variant="outlined"
      disabled={disabled}
      onClick={handleExportToExcel}
      startIcon={<i className="far fa-file-excel"></i>}
      style={{
        width: "auto",
        height: 35,
        display: "flex",
        justifyContent: "space-between",
        padding: "0 14px",
        fontSize: 14,
        color: `${disabled ? "grey" : "#217346"}`,
        border: `1px solid ${disabled ? "grey" : "#217346"}`,
        backgroundColor: "#fff",
      }}
    >
      {label}
    </Button>
  );
};
